export default __webpack_public_path__ + "static/media/bg.7a34e843.jpeg";